import { RouteConfig } from "vue-router";
import { dashboard } from "./dashboard";

export const app = (): Array<RouteConfig> => [...dashboard()];
